const initialState = {
    userInfo: null,
    loading: false,
    error: null,
    externalUser: null
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER_LOGIN_REQUEST':
            return { ...state, loading: true, error: null };
        case 'USER_LOGIN_SUCCESS':
            return { ...state, loading: false, userInfo: action.payload };
        case 'USER_LOGIN_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'CREATE_EXTERNAL_USER':
            return { ...state, loading: true, error: null };
        case 'CREATE_EXTERNAL_USER_SUCCESS':
            return { ...state, loading: false, externalUser: action.payload };
        case 'CREATE_EXTERNAL_USER_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'CREATE_EXTERNAL_USER_ERROR':
            return { ...state, loading: false, error: action.payload };
        case 'REGISTER_EXTERNAL_USER_REQUEST':
            return { ...state, loading: true, error: null };
        case 'REGISTER_EXTERNAL_USER_SUCCESS':
            return { ...state, loading: false };
        case 'REGISTER_EXTERNAL_USER_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'VALIDATE_EXTERNAL_USER_REQUEST':
            return { ...state, loading: true, error: null };
        case 'VALIDATE_EXTERNAL_USER_SUCCESS':
            return { ...state, loading: false, userInfo: action.payload };
        case 'VALIDATE_EXTERNAL_USER_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'SEND_OTP_LOGIN_REQUEST':
            return { ...state, loading: true, error: null };
        case 'SEND_OTP_LOGIN_SUCCESS':
            return { ...state, loading: false };
        case 'SEND_OTP_LOGIN_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'VALIDATE_LOGIN_OTP_REQUEST':
            return { ...state, loading: true, error: null };
        case 'VALIDATE_LOGIN_OTP_SUCCESS':
            return { ...state, loading: false, userInfo: action.payload };
        case 'VALIDATE_LOGIN_OTP_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'USER_LOGOUT':
            return {
                ...state,
                userInfo: null,
            };
        case 'CLEAR_ERROR':
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export default userReducer;
